import api from "@/service/api";

const state = () => ({
    refillCommissionPercentage: null,
    landingPages: null,
    currentBonusPercentage: null,
    copiedUrl: null,
    url: null,
    slug: null,
    affiliateBrand: null,
    highValue: null,
    influencer: null,
})

const mutations = {
    setRefillCommissionPercentage(state, value) {
        state.refillCommissionPercentage = value
    },
    setLandingPages(state, value) {
        state.landingPages = value
    },
    setCurrentBonusPercentage(state, value) {
        state.currentBonusPercentage = value
    },
    setCopiedUrl(state, value) {
        state.copiedUrl = value
    },
    setAffiliateBrand(state, value) {
        state.affiliateBrand = value
    },
    setUrl(state, value) {
        state.url = value
    },
    setSlug(state, value) {
        state.slug = value
    },
    setHighValue(state, value) {
        state.highValue = value
    },
    setInfluencer(state, value) {
        state.influencer = value
    },
}

const actions = {
    refresh({ commit }) {
        api.post('/affiliate/dashboard/index')
            .then(response => {
                if (response?.data?.url) {
                    commit('setUrl', response.data.url);
                }

                if (response?.data?.refillCommissionPercentage) {
                    commit('setRefillCommissionPercentage', response.data.refillCommissionPercentage);
                }

                if (response?.data?.landingPages) {
                    commit('setLandingPages', response.data.landingPages);
                }

                if (response?.data?.currentBonusPercentage) {
                    commit('setCurrentBonusPercentage', response.data.currentBonusPercentage);
                }

                commit('setSlug', response?.data?.slug);
                commit('setAffiliateBrand', response?.data?.brand);
                commit('setHighValue', response?.data?.highValue);
                commit('setInfluencer', response?.data?.influencer);
            })
    }
}


export default {
    namespaced: true,
    state,
    actions,
    mutations
}
